import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { compose, lifecycle, withState } from 'recompose';
import {
  renderWhileLoading,
  setRefetchProp,
  renderForError
} from '../../../../../state/apolloRecompose';

import UploadAccountHolders from './UploadAccountHolders';
import withHandlers from './enhancers/withHandlers';
import withCreateManyAccountHoldersMutation from './enhancers/withCreateManyAccountHoldersMutation';

const ComposedUploadAccountHolders = compose(
  withState('data', 'updateData', []),
  withState('erroredAccountHolders', 'updateErroredAccountHolders', []),
  withState('uploadError', 'updateUploadError', false),
  withState('error', 'updateError', null),
  lifecycle({
    componentDidMount() {
      const { updateData } = this.props;

      this.props.location.state.data &&
        updateData([...this.props.location.state.data]);
    }
  }),
  withCreateManyAccountHoldersMutation,
  withHandlers,
  renderWhileLoading,
  setRefetchProp,
  renderForError
)(UploadAccountHolders);

// Wrapper to inject navigate and location for React Router v6 compatibility
export default function UploadAccountHoldersWrapper(props) {
  const navigate = useNavigate();
  const location = useLocation();

  // Create history-like object with push method for compatibility
  const history = {
    push: (pathOrOptions) => {
      if (typeof pathOrOptions === 'string') {
        navigate(pathOrOptions);
      } else {
        // Handle { pathname, state } object
        navigate(pathOrOptions.pathname, { state: pathOrOptions.state });
      }
    }
  };

  return <ComposedUploadAccountHolders {...props} history={history} location={location} />;
}
